import http from '../utils/http.js'
import md5 from 'js-md5';
// 个人注册
export function register(data){
    // data.password = md5(data.password)
    return http.post('/enterpriseMember/register',  {...data, password: md5(data.password)})
}

export function getEnterpriseMember(id){
    return http.get('/enterpriseMember/getEnterpriseMember/' + id)
}
export function pageQuery(data){
    // {
    //     "username": ""
    //   }
    return http.post(`/enterpriseMember/pageQuery/${data.page}/${data.size}`, data)
}
export function update(data){
    return http.put(`/enterpriseMember/update`, data)
}